import { NgModule } from '@angular/core';

import { PreregisterNavigationAccessService } from './preregister-navigation-access.service';
import { PreregisterComponent } from './preregister.component';
import { CommonModule } from '@angular/common';
import { CxFormsModule } from '@forms';
import { FormsModule } from '@angular/forms';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        CxFormsModule
    ],
    declarations: [PreregisterComponent],
    exports: [PreregisterComponent],
    providers: [
        PreregisterNavigationAccessService
    ]
})
export class PreregisterModule {}

export {
    PreregisterNavigationAccessService,
    PreregisterComponent
}
